import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface BarGraphNoDataProps {
  empty?: boolean;
}

export const BarGraphNoData: React.FC<BarGraphNoDataProps> = ({ empty }) => {
  const [styles] = useStyles();
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.h3BoldWithFontSize}>{i18n.t('no_sales_data')}</Text>
        <Text style={styles.h4BoldWithFontSize}>
          {empty
            ? i18n.t('no_sales_data_for_item')
            : i18n.t('no_sales_data_selected_range')}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    height: 224,
    justifyContent: 'space-around',
  },
  h3BoldWithFontSize: {
    ...TYPOGRAPHY.h3,
    fontSize: 16,
    lineHeight: 24,
  },
  h4BoldWithFontSize: {
    ...TYPOGRAPHY.h4,
    color: theme.colors.inactiveText,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
  },
  textContainer: {
    alignItems: 'center',
  },
}));
